import { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import classes from './PlansContainer.module.css';

const PlansContainer = props => {
  const [selectedPlan, setSelectedPlan] = useState(0);

  const changePlanHandler = plan => () => {
    console.log(plan);
    setSelectedPlan(plan);
  };

  const formatCurrency = number => {
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    return formatter.format(number);
  };

  return (
    <div className={classes.programsContainer}>
      {!props.selected && (
        <aside className={classes.programPlansBtns}>
          <p className={classes.programPlansBtns__title}>
            Elige tu plan de pago
          </p>
          {props.paymentPlans.map((plan, index) => (
            <Button
              key={plan.planId}
              onClick={changePlanHandler(index)}
              className={`${classes.programPlanBtn} ${
                selectedPlan === index &&
                classes.programPlanBtnSelected
              }`}
            >
              Plan de pago {index + 1}
            </Button>
          ))}
        </aside>
      )}

      <div
        className={
          !props.selected
            ? classes.plansContainer
            : classes.plansContainerSelected
        }
      >
        {!props.selected && (
          <p className={classes.planName}>
            {props.paymentPlans[selectedPlan].paymentPlanName}
          </p>
        )}
        <section className={classes.planTableContainer}>
          <p className={classes.tablePlanDataConcept}>CONCEPTO</p>
          <p className={classes.tablePlanData}>MONTO DE PAGO</p>
          <p className={classes.tablePlanData}>FECHA DE PAGO</p>
          {!props.selected
            ? props.paymentPlans[selectedPlan].paymentPlan.map(
                plan => (
                  <aside
                    key={plan.id}
                    style={{ borderBottom: '1px solid gray' }}
                  >
                    <p className={classes.planConceptItem}>
                      {plan.concept}
                    </p>
                    <p className={classes.planDataItem}>
                      {this.formatCurrency(plan.amount / 100)}
                    </p>
                    <p
                      style={{ color: '#5b6364' }}
                      className={classes.planDataItem}
                    >
                      {plan.pay_date}
                    </p>
                  </aside>
                )
              )
            : props.paymentPlans.map(plan => (
                <aside
                  key={plan.id}
                  style={{ borderBottom: '1px solid gray' }}
                >
                  <p className={classes.planConceptItem}>
                    {plan.concept}
                  </p>
                  <p className={classes.planDataItem}>
                    {formatCurrency(plan.amount / 100)}
                  </p>
                  <p
                    style={{ color: '#5b6364' }}
                    className={classes.planDataItem}
                  >
                    {plan.pay_date}
                  </p>
                </aside>
              ))}
          {!props.selected && (
            <aside className={classes.btnContainer}>
              <Button className={classes.btnSend}>
                Elegir este Plan de Pago
              </Button>
            </aside>
          )}
        </section>
      </div>
    </div>
  );
};

PlansContainer.propTypes = {
  // eslint-disable-next-line react/require-default-props
  showPlans: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  paymentPlans: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  selected: PropTypes.bool
};

export default PlansContainer;
